import {Product} from "~/utils/Product";

export type ArticleInventoryStatus = "in_stock" | "on_event" | "internal_use" | "in_service" | "sold";

export type ArticleAssignmentSummary = {
    id: number;
    title: string;
}

export class Article {
    id = 0;
    article_number = "";
    details = "";
    anzahl_auftraege = 0;
    kaufdatum:Date|null = null
    neupreis = 0;
    product:Product = new Product()
    verkaufsdatum:Date|null = null
    verkaufspreis:number|null = null
    inventoryStatus: ArticleInventoryStatus = "in_stock"
    activeEvent: ArticleAssignmentSummary | null = null
    activeService: ArticleAssignmentSummary | null = null
    activeInternalUse = false
    currentCase: { id: number, name: string, barcode: string, trackingMode: "fixed" | "flexible" } | null = null

    fromJSON(obj: Partial<Article>): Article {
        return Object.assign(new Article(), obj)
    }

    parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
        this.id = ret.id;
        this.article_number = ret.attributes.article_number;
        this.details = ret.attributes.Details ?? ""
        this.anzahl_auftraege = ret.attributes.anzahl_auftraege ?? 0
        this.kaufdatum = ret.attributes.kaufdatum ?? null
        this.neupreis = ret.attributes.neupreis ?? 0
        this.verkaufsdatum = ret.attributes.verkaufsdatum ?? null
        this.verkaufspreis = ret.attributes.verkaufspreis ?? null
        this.inventoryStatus = ret.attributes.inventoryStatus ?? "in_stock"
        this.activeEvent = this.parseAssignment(ret.attributes.activeEvent?.data)
        this.activeService = this.parseAssignment(ret.attributes.activeService?.data)
        this.activeInternalUse = ret.attributes.activeInternalUse ?? false
        this.currentCase = this.parseCaseSummary(ret.attributes.currentCase?.data)
        if(ret.attributes.product && ret.attributes.product.data){
            this.product = new Product()
            this.product.parseJson(ret.attributes.product.data)
        }
    }

    private parseCaseSummary(value:any): { id: number, name: string, barcode: string, trackingMode: "fixed" | "flexible" } | null {
        if(!value){
            return null
        }
        return {
            id: value.id,
            name: value.name ?? value.attributes?.name ?? `Case ${value.id}`,
            barcode: value.barcode ?? value.attributes?.barcode ?? "",
            trackingMode: value.trackingMode ?? value.attributes?.trackingMode ?? "fixed"
        }
    }

    private parseAssignment(value:any): ArticleAssignmentSummary | null {
        if(!value){
            return null
        }
        return {
            id: value.id,
            title: value.Name ?? value.attributes?.Name ?? `Eintrag ${value.id}`
        }
    }

    toJSON () {
        return {
            article_number: this.article_number,
            Details: this.details,
            anzahl_auftraege: this.anzahl_auftraege,
            kaufdatum: this.kaufdatum,
            neupreis: this.neupreis,
            verkaufsdatum: this.verkaufsdatum,
            verkaufspreis: this.verkaufspreis,
            product: this.product?.id > 0 ? this.product.id : null,
        }
    }
}
